const mutations = {
    SET_LOGIN_HINT(state, hint) {
        state.loginHint = hint
    },
    CLEAR_LOGIN_HINT(state) {
        state.loginHint = {}
    },
    APPEND_FLASH_MESSAGE(state, properties) {
        state.flash.push(properties)
    },
    SET_RIGHT_DRAWER_OPEN(state, open) {
        state.navigation.rightDrawerOpen = open
    },
    SET_RIGHT_RAIL_OPEN(state, open) {
        state.navigation.rightRailOpen = open
    },
    CLOSE_DRAWERS(state) {
        state.navigation.leftDrawerOpen = false
        state.navigation.rightDrawerOpen = false
    },
    SHOW_RIGHT_DRAWER_CONTENT(state, content) {
        state.navigation.rightDrawerOpen = true
        state.navigation.rightRailOpen = true
        state.rightDrawerContent = content
    },
    CLEAR_RIGHT_DRAWER(state) {
        state.rightDrawerContent = null
    },
    SET_CURRENT_ENTITY(state, entity) {
        state.currentEntity = entity
    },
    CLEAR_CURRENT_ENTITY(state) {
        state.currentEntity = null
    },
    SET_POPOVER_CONTENT(state, popover) {
        state.popover.content = popover
    },
    SET_POPOVER_OPEN(state, value) {
        state.popover.open = value
    },
    SET_SEARCH_MODAL_OPEN(state, value) {
        state.searchModal.open = value
    },
    SET_SEARCH_MODAL_SEARCH(state, value) {
        state.searchModal.search = value
    },
    SET_COUNTRIES(state, countries) {
        state.geography.countries = countries
    },
    SET_EXCHANGES(state, exchanges) {
        state.markets.exchanges = exchanges
    },
    SET_CUSTOM_WORK_CONFIGURATION(state, configuration) {
        state.customWork = configuration
    },
    SET_JOB_ROLES_CONFIGURATION(state, configuration) {
        state.jobRoles = configuration
    },
}

const types = Object.getOwnPropertyNames(mutations).reduce((map, property) => {
    map[property] = property
    return map
}, {})

export { types as default, mutations }
